var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#091f82",
    d: "M 27.5,4.5 C 27.335,7.8499 27.5017,11.1832 28,14.5C 31.3936,15.4558 34.8936,15.7892 38.5,15.5C 38.5,24.5 38.5,33.5 38.5,42.5C 28.5,42.5 18.5,42.5 8.5,42.5C 8.5,29.8333 8.5,17.1667 8.5,4.5C 14.8333,4.5 21.1667,4.5 27.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2974cd",
    d: "M 27.5,4.5 C 31.5,7.83333 35.1667,11.5 38.5,15.5C 34.8936,15.7892 31.3936,15.4558 28,14.5C 27.5017,11.1832 27.335,7.8499 27.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0174d0",
    d: "M 31.5,25.5 C 31.5,24.8333 31.1667,24.5 30.5,24.5C 30.5106,22.3141 31.5106,21.4808 33.5,22C 34.8398,24.1489 34.1731,25.3155 31.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1082d5",
    d: "M 30.5,24.5 C 31.1667,24.5 31.5,24.8333 31.5,25.5C 29.831,27.5089 28.1643,29.5089 26.5,31.5C 24.8606,29.1939 22.8606,27.1939 20.5,25.5C 18.3078,26.8587 16.6411,28.6921 15.5,31C 13.3333,31.5 12.5,30.6667 13,28.5C 16.0044,26.6608 18.5044,24.3274 20.5,21.5C 22.1394,23.8061 24.1394,25.8061 26.5,27.5C 27.8518,26.4756 29.1851,25.4756 30.5,24.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMenuIcon);
export default __webpack_public_path__ + "static/media/report_menu_icon.ec4569f19621494e2958dc9958bc7d83.svg";
export { ForwardRef as ReactComponent };